import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ClientCarousel.css'
import '../App.css'
import photoshop from '../assets/imgs/photoshop.svg';
import illustrator from '../assets/imgs/illustrator.svg';
import afterAffect from '../assets/imgs/aftereffects.svg';
import xd from '../assets/imgs/xd.svg';
import framer from '../assets/imgs/framer1.svg';
import shopify from '../assets/imgs/Shopify1.svg';
import wix from '../assets/imgs/wix1.svg';
import figma from '../assets/imgs/figma1.svg';
import indesign from '../assets/imgs/indesign1.svg';

const ClientCarousel = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: isMobile ? null : <SampleNextArrow />,
        prevArrow: isMobile ? null : <SamplePrevArrow />,
    };

    return (
        <div className="client-logo-slider">
            <div className="container">
                <Slider {...settings}>
                    <div className="logo-item"><img src={photoshop} alt="Photoshop" /></div>
                    <div className="logo-item"><img src={illustrator} alt="Illustrator" /></div>
                    <div className="logo-item"><img src={afterAffect} alt="After Effects" /></div>
                    <div className="logo-item"><img src={xd} alt="Adobe XD" /></div>
                    <div className="logo-item"><img src={framer} alt="Framer" /></div>
                    <div className="logo-item"><img src={shopify} alt="Shopify" /></div>
                    <div className="logo-item"><img src={wix} alt="Wix" /></div>
                    <div className="logo-item"><img src={figma} alt="Figma" /></div>
                    <div className="logo-item"><img src={indesign} alt="InDesign" /></div>
                    {/* Add more logo items as needed */}
                </Slider>
            </div>
        </div>
    );
};

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div className={`${className} btn-custom next-slide`} style={{ ...style }} onClick={onClick}>&gt;</div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div className={`${className} btn-custom prev-slide`} style={{ ...style }} onClick={onClick}>&lt;</div>
    );
}

export default ClientCarousel;
